import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';

import { Form } from 'ui/components';

const initialState = {
  units: [
    {
      unit: null,
    },
  ],
};
export const FormUnit = ({ datas, onInputChange }) => {
  const StateForm = useSelector((state) => state.Form);
  const [{ units }, setState] = React.useState(initialState);

  const $handleItemsChange = async (i, e) => {
    let newUnits = [...units];

    newUnits[i]['unit'] = e.target.value;

    setState((prevState) => ({
      ...prevState,
      units: newUnits,
    }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      units: [
        ...units,
        {
          unit: null,
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newUnits = [...units];
    newUnits.splice(i, 1);
    setState((prevState) => ({
      ...prevState,
      units: newUnits,
    }));
  };

  React.useEffect(() => {
    const input = {
      units,
    };

    onInputChange(input);
  }, [units]);

  React.useEffect(() => {
    if (!datas) return;

    let us = [];
    if (datas) {
      datas?.forEach((i) => {
        us.push({
          id: i?.id,
          unit: i.unit,
        });
      });
    }
    setState((prevState) => ({ ...prevState, units: us }));
  }, [datas]);

  React.useEffect(() => {
    if (!datas) {
      setState(initialState);
    }
  }, []);

  return (
    <div className="mt-3">
      <div className="fw-semibold py-2 fs-6 ">Pengaturan Unit</div>
      {units?.map((e, i) => (
        <div
          className={cn('row align-items-end border-bottom py-3 m-0')}
          key={i}
        >
          <div className="col-10">
            <Form.Input
              required
              label="Unit"
              type="text"
              value={e?.unit}
              onChange={(e) => $handleItemsChange(i, e)}
              error={StateForm?.errors[`units.${i}.unit`]}
            />
          </div>
          <div className="col-2 ">
            <button
              type="button"
              className="btn btn-danger rounded mb-3"
              style={{ minHeight: 36, minWidth: '100%' }}
              onClick={() => $removeField(i)}
              disabled={units?.length === 1 || i === 0}
            >
              <Fi.FiX />
            </button>
          </div>
        </div>
      ))}

      <div className="mt-3">
        <button
          type="button"
          className="btn btn-primary rounded mb-3"
          style={{ minHeight: 36, minWidth: '100%' }}
          onClick={() => $addMoreFields()}
        >
          <Fi.FiPlus className="me-2" /> Tambah Unit
        </button>
      </div>
    </div>
  );
};
